import { useMutation } from "react-query";
import { createKitchenOrders } from "../../../services/kitchen";

export const useCreateKitchenOrderMutation = () => {
  return useMutation(["createKitchenOrderMutation"], createKitchenOrders);
};
